import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './plugins/element.js'
import axios from 'axios'
import Qs from 'qs'
import selectMultiple from '@/components/common/selectMultiple.vue'
import '@/assets/font/tableButtonIcon.css'
import '@/assets/font/common/iconfont.css'
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import {
  UTableColumn,
  UTable,
  UxGrid,
  UxTableColumn
} from 'umy-ui'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { PieChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  DatasetComponentOption,
  TransformComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';


// vue-cookies配置
import cookies from 'vue-cookies'
Vue.prototype.$cookies = cookies;

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  PieChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
])
Vue.prototype.$echarts = echarts;
axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  'Accept': '*/*'
}
axios.defaults.baseURL = process.env.VUE_APP_LOCALHOST ? '/api' : '/'
let loginRedirecting = false
axios.interceptors.response.use((response) => {
  const data = response && response.data
  if (data && (data.result == -1 || data.result === '-1') && !loginRedirecting) {
    if (router.currentRoute && router.currentRoute.name === 'Login') {
      return response
    }
    loginRedirecting = true
    if (data.message) {
      alert(data.message)
    }
    const base = process.env.VUE_APP_LOCALHOST
      ? process.env.VUE_APP_LOCALHOST
      : `${window.location.protocol}//${window.location.host}/`
    window.top.location.href = base + (base.endsWith('/') ? '' : '/') + 'templates/vue-account/dist/index.htm'
  }
  return response
}, (error) => Promise.reject(error))
Vue.config.productionTip = true
Vue.prototype.$http = axios
import { newPost } from '@/assets/js/common.js'
Vue.prototype.$post = newPost
Vue.prototype.Qs = Qs
Vue.component('selectMultiple', selectMultiple)
Vue.use(UTableColumn)
Vue.use(UTable)
Vue.use(UxGrid)
Vue.use(UxTableColumn)
Vue.use(elTableInfiniteScroll)
router.beforeEach((to, from, next) => {
  store.dispatch('onLoading', true);
//   console.log(store.state.isLoading);
  next();
});
router.afterEach((to, from) => {
  store.dispatch('onLoading', false);
//   console.log(store.state.isLoading);
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



let tempToFixed = Number.prototype.toFixed
Number.prototype.toFixed = function(digits) {
    // console.warn('toFixed方法不建议使用，请使用toFixedRoundUp')
    return tempToFixed.call(this, digits)
};
// reserve 是否保留无效零
Number.prototype.toFixedRoundUp = function(digits, reserve) {
    // console.log('this is toFixedRoundUp')
    if(isNaN(this)) {
        console.error('Uncaught TypeError: ' + this + ' is not a number')
        return this
    }
    // 确定要保留的小数位数
    digits = digits || 0;
    
    // 计算乘数
    let multiplier = Math.pow(10, digits);
    
    // 使用标准的四舍五入进行计算
    // let result = Math.round(this * multiplier) / multiplier;
    let result = Math.round(Number(((this || 0)*multiplier).toFixed(2)) )/multiplier
    // 将结果转换为字符串并格式化
    let resultString = result.toString();
    if(!reserve){
        return resultString
    }
    // 确保结果有足够的小数位数
    if (digits > 0) {
        let parts = resultString.split('.');
        if (parts.length === 1) {
            resultString += '.';
            for (let i = 0; i < digits; i++) {
                resultString += '0';
            }
        } else {
            let decimalPart = parts[1];
            while (decimalPart.length < digits) {
                decimalPart += '0';
            }
            resultString = parts[0] + '.' + decimalPart;
        }
    }
    
    return resultString;
};